<template>
   <el-dialog class="form" @close="$emit('close')" :title="title" :visible="visible" modal-append-to-body append-to-body>
      <form ref='form' @submit.prevent="$emit('submit', $refs.form)">
         <slot></slot>
         <span slot="footer" class="dialog-footer">
            <atom-button @click="$emit('close')">{{ close_text }}</atom-button>
            <atom-button type="submit" color="primary">{{ submit_text }}</atom-button>
         </span>
      </form>
   </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import AtomButton from '../../../atoms/Login/Button';

export default {
   components: {
      'el-dialog': Dialog,
      AtomButton,
   },
   props: {
      visible: {
         type: Boolean,
         required: true,
      },
      title: {
         type: String,
         requried: true,
      },
      submit_text: {
         type: String,
         default: "Confirm",
      },
      close_text: {
         type: String,
         default: "Cancel",
      },
   },
}
</script>

<style lang="scss" scoped>
form {
   padding: 0 1em 1em 1em;
   font-size: 1rem;
   .dialog-footer {
      display: flex;
      justify-content: flex-end;
      button {
         margin: 0.4em;
      }
   }
}
</style>
